

import { createSlice } from "@reduxjs/toolkit";
import { verifyWholesaler } from "./ThunkAction";
import { REDUCER_NAME } from "./Types"; 


const initialState = {
  isLoading: false,
  errorMessage: null,
};

export const verifyWholesalerSlice = createSlice({
  name: REDUCER_NAME,
  initialState,
  reducers: {
    resetVerifyState: () => {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
    
      .addCase(verifyWholesaler.pending, (state) => {
        state.isLoading = true;
        state.errorMessage = null;
      })
      .addCase(verifyWholesaler.fulfilled, (state, action) => {
        state.isLoading = false;
      })
      .addCase(verifyWholesaler.rejected, (state, action) => {
        state.errorMessage = "Failed to verify wholesaler";
        state.isLoading = false;
      });
  },
});

export const { resetVerifyState } = verifyWholesalerSlice.actions;
export default verifyWholesalerSlice.reducer;